
declare var moment: any;
namespace Nobox {
    import Option = Serenity.Decorators.option
    export interface DatePickerEditorOptions {
        timeZone: string;
    }
    @Serenity.Decorators.registerEditor('Custom.CustomDateFilter', [Serenity.IStringValue, Serenity.IReadOnly])
    @Serenity.Decorators.element('<input type="text"/>')
    export class CustomDateFilter extends Serenity.Widget<any> implements Serenity.IStringValue, Serenity.IReadOnly {

        private minValue: string;
        private maxValue: string;
        private minDate: string;
        private maxDate: string;
        private sqlMinMax: boolean;
        private end: JQuery;
        private start: JQuery;

        constructor(input: JQuery, opt: DatePickerEditorOptions) {
            super(input, opt);   
            if (this.getCookie("timezone") == undefined || this.getCookie("timezone") == "" || this.getCookie("timezone") == null) {
                this.timezone = "Asia/Jakarta";
            } else {
                this.timezone = this.regexDateTime(this.getCookie("timezone"));
            }
            this.start = input;
            //input.addClass('dateQ');
            $.datepicker.parseDate = function (format, value) {
                if (!value) {
                    return moment.toDate();
                } else {
                    return moment(value, format).toDate();
                }
            };
            $.datepicker.formatDate = function (format, value) {
                return moment(value).format(format);
            };
            input.datepicker({
                showOn: 'button',
                beforeShow: (inp, inst) => {
                    return !input.hasClass('readonly') as any;
                },
                yearRange: Q.coalesce(this.yearRange, '-100:+50'),
                dateFormat: this.regexDateTime(this.getCookie("formatdate"))
            });
            input.addClass("s-Serenity-DateEditor s-DateEditor");
            this.end = $(`<input type="text" class="s-Serenity-DateEditor s-DateEditor">`);
            input.parent().append(`<span class="range-separator">-</span>`);
            input.parent().append(this.end);
            this.end.datepicker({
                showOn: 'button',
                beforeShow: (inp, inst) => {
                    return !input.hasClass('readonly') as any;
                },
                yearRange: Q.coalesce(this.yearRange, '-100:+50'),
                dateFormat: this.regexDateTime(this.getCookie("formatdate"))
            });
            this.end.change(() => {
                input.triggerHandler('change')
            });

            Serenity.VX.addValidationRule(input, this.uniqueName, e1 => {
                var value = this.get_value();
                if (Q.isEmptyOrNull(value)) {
                    return null;
                }

                return null;
            });
        }

        regexDateTime(format) {
            return format.replace(new RegExp("%2C", 'g'), ",").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%20", 'g'), " ").replace(new RegExp("%3A", 'g'), ":");
        }

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);

            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }
        get_value(): string {
            var value = this.element.val().trim();
            if (value != null && value.length === 0) {
                return null;
            }
            return moment(value, this.regexDateTime(this.getCookie("formatdate"))).tz(this.regexDateTime(this.getCookie("timezone"))).utc().format('YYYY-MM-DDTHH:mm:ss.SSS');
        }

        get value(): string {
            return this.get_value();
        }

        set_value(value: string) {
            if (value == null) {
                this.element.val('');
            }
            else if (value.toLowerCase() === 'today' || value.toLowerCase() === 'now') {
                var xx = moment().tz(this.regexDateTime(this.getCookie("timezone"))).format(this.regexDateTime(this.getCookie("formatdate")));
                this.element.val(xx);
            }
            else if (value.toLowerCase() === 'tomorrow') {
                var xx = moment().add(1, 'days').tz(this.regexDateTime(this.getCookie("timezone"))).format(this.regexDateTime(this.getCookie("formatdate")));
                this.element.val(xx);
            }
            else {
                if (value.search("T") == -1) {
                    this.element.val(moment(value).format(this.regexDateTime(this.getCookie("formatdate"))));
                } else {
                    this.element.val(moment(value).format(this.regexDateTime(this.getCookie("formatdate"))));
                }
            }
        }

        set value(v: string) {
            this.set_value(v);
        }

        end_get_value(): string {
            var value = this.end.val().trim();
            if (value != null && value.length === 0) {
                return null;
            }
            return moment(value, this.regexDateTime(this.getCookie("formatdate"))).add(1, "d").tz(this.regexDateTime(this.getCookie("timezone"))).utc().format('YYYY-MM-DDTHH:mm:ss.SSS');
        }

        get endvalue(): string {
            return this.end_get_value();
        }

        end_set_value(value: string) {
            if (value == null) {
                this.end.val('');
            }
            else if (value.toLowerCase() === 'today' || value.toLowerCase() === 'now') {
                var xx = moment().tz(this.regexDateTime(this.getCookie("timezone"))).format(this.regexDateTime(this.getCookie("formatdate")));
                this.end.val(xx);
            }
            else if (value.toLowerCase() === 'tomorrow') {
                var xx = moment().add(1, 'days').tz(this.regexDateTime(this.getCookie("timezone"))).format(this.regexDateTime(this.getCookie("formatdate")));
                this.end.val(xx);
            }
            else {
                if (value.search("T") == -1) {
                    this.end.val(moment(value).format(this.regexDateTime(this.getCookie("formatdate"))));
                } else {
                    this.end.val(moment(value).format(this.regexDateTime(this.getCookie("formatdate"))));
                }
            }
        }

        set endvalue(v: string) {
            this.end_set_value(v);
        }

        get_readOnly(): boolean {
            return this.element.hasClass('readonly');
        }

        set_readOnly(value: boolean): void {

            if (value !== this.get_readOnly()) {
                if (value) {
                    this.element.addClass('readonly').attr('readonly', 'readonly');
                    this.element.nextAll('.ui-datepicker-trigger').css('opacity', '0.1');
                }
                else {
                    this.element.removeClass('readonly').removeAttr('readonly');
                    this.element.nextAll('.ui-datepicker-trigger').css('opacity', '1');
                }
            }
        }

        @Option()
        public yearRange: string;
        public timezone: string;
    }

}